import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-93fee96a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-builder-page" }
const _hoisted_2 = { class: "page-title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "page-title-text-area" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Game Builder")
], -1))
const _hoisted_4 = { class: "token" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-label" }, "FS token", -1))
const _hoisted_6 = { class: "game-fields" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-label" }, "Title", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-label" }, "Subtitle", -1))
const _hoisted_9 = {
  key: 0,
  class: "error"
}
const _hoisted_10 = {
  key: 2,
  class: "editor"
}
const _hoisted_11 = { class: "cards" }
const _hoisted_12 = {
  key: 0,
  class: "cards-count"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "card-thumb" }
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "card-info" }
const _hoisted_17 = { class: "card-name" }
const _hoisted_18 = {
  key: 0,
  class: "rel-squares"
}
const _hoisted_19 = ["title"]
const _hoisted_20 = {
  key: 0,
  class: "card-editor"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Card info", -1))
const _hoisted_22 = { class: "person-id" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Person id", -1))
const _hoisted_24 = {
  key: 0,
  class: "value"
}
const _hoisted_25 = ["disabled"]
const _hoisted_26 = { class: "fields" }
const _hoisted_27 = { class: "field-row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label form-label" }, "Name", -1))
const _hoisted_29 = { class: "field-row" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label form-label" }, "Relationship", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-hint" }, "(FM = father's mother)", -1))
const _hoisted_32 = {
  key: 0,
  class: "field-row"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label" }, null, -1))
const _hoisted_34 = { class: "rel-squares" }
const _hoisted_35 = { class: "field-row" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label form-label" }, "Text", -1))
const _hoisted_37 = { class: "field-row" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label form-label" }, "Sibling order", -1))
const _hoisted_39 = ["value"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-hint" }, "of", -1))
const _hoisted_41 = ["value"]
const _hoisted_42 = { class: "field-row" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label form-label" }, "Children", -1))
const _hoisted_44 = ["value"]
const _hoisted_45 = { class: "field-row" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label form-label" }, "Flag", -1))
const _hoisted_47 = {
  key: 1,
  class: "flag-country"
}
const _hoisted_48 = { class: "field-row field-notes" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "field-label form-label" }, "Notes", -1))
const _hoisted_50 = { class: "images" }
const _hoisted_51 = ["src"]
const _hoisted_52 = {
  key: 2,
  class: "thumbnails"
}
const _hoisted_53 = ["onPointerdown", "onPointermove", "onPointerup", "onPointercancel", "onWheel"]
const _hoisted_54 = ["src"]
const _hoisted_55 = {
  key: 0,
  class: "image-actions"
}
const _hoisted_56 = ["disabled"]
const _hoisted_57 = ["disabled"]
const _hoisted_58 = ["disabled"]
const _hoisted_59 = { class: "details" }
const _hoisted_60 = { class: "details-side" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "details-label" }, "Details", -1))
const _hoisted_62 = { class: "details-actions" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = { class: "details-list" }
const _hoisted_65 = {
  key: 0,
  class: "select-all"
}
const _hoisted_66 = ["checked", "indeterminate"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Select all", -1))
const _hoisted_68 = ["checked", "onChange"]
const _hoisted_69 = { class: "detail-date" }
const _hoisted_70 = { class: "detail-age" }
const _hoisted_71 = { class: "detail-body" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = {
  key: 0,
  class: "detail-place"
}
const _hoisted_74 = { class: "danger-zone" }
const _hoisted_75 = ["disabled"]
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Delete this card? This can't be undone.", -1))

import { computed, onMounted, onUnmounted, ref, watch } from 'vue'
import { debounce } from 'lodash'
import { useGamesApi, GameCardDetail, GameCardInfo, GameCardImage } from './GamesApi'
import { readGameSourcePerson, readGameSourceImages, SourceImage } from './FamilySearchGameSource'
import { vFocal, panFocal, zoomFocalToward } from './vFocal'
import { formatDate, parseDate } from './matching/MatchingGameHelpers'
import { GeoUtil, CountryCodes } from '@/util/GeoUtil'
import NewCardModal from './NewCardModal.vue'
import EditDetailModal from './EditDetailModal.vue'
import ImageGalleryModal from './ImageGalleryModal.vue'
import Modal from '@/util/Modal.vue'
import LoadingIndicator from '@/util/LoadingIndicator.vue'
import { useConfirmation } from '@/util/Confirmation'
import { PlusIcon, Trash2Icon, ChevronLeftIcon, ChevronRightIcon } from '@zhuowenli/vue-feather-icons'

const TOKEN_STORAGE_KEY = 'fsGameToken'

export default /*#__PURE__*/_defineComponent({
  __name: 'GameBuilderPage',
  props: {
    gameId: {}
  },
  setup(__props: any) {

const props = __props;



const gamesApi = useGamesApi()

// Temporary FamilySearch access token, kept in localStorage so it survives a reload -- this
// whole token flow is throwaway authoring scaffolding and will be removed later.
const tokenRef = ref('')

const gameIdRef = ref<string>()
const titleRef = ref('')
const subtitleRef = ref('')
const cardsRef = ref<GameCardInfo[]>([])
const selectedCardIdRef = ref<string>()
const selectedImageIdRef = ref<string>()

// Session-only map -- GameCardInfo has no field for a card's FS memories gallery, so it isn't
// persisted; it's populated when a card is imported, re-read, or the add-image picker is first opened.
const galleryByCardIdRef = ref<Record<string, SourceImage[]>>({})
const loadingGalleryRef = ref(false)

const loadingRef = ref(false)
const savingRef = ref(false)
const errorRef = ref('')

const newCardModalRef = ref<InstanceType<typeof NewCardModal>>()
const editDetailModalRef = ref<InstanceType<typeof EditDetailModal>>()
const editDetailRef = ref<GameCardDetail>()
const imageGalleryModalRef = ref<InstanceType<typeof ImageGalleryModal>>()
const deleteModalRef = ref<InstanceType<typeof Modal>>()
const confirmDelete = useConfirmation(deleteModalRef)

// Cards are shown in name order (case-insensitive, unnamed last).
const sortedCardsRef = computed(() => {
  return [...cardsRef.value].sort((a, b) => {
    const an = a.name?.trim().toLowerCase() ?? ''
    const bn = b.name?.trim().toLowerCase() ?? ''
    if (!an && !bn) {
      return 0
    }
    if (!an) {
      return 1
    }
    if (!bn) {
      return -1
    }
    return an.localeCompare(bn)
  })
})

const selectedCardRef = computed(() => cardsRef.value.find(c => c.id === selectedCardIdRef.value))
const selectedPersonIdRef = computed(() => selectedCardRef.value?.sourcePersonId)
const selectedGalleryRef = computed(() => selectedCardIdRef.value ? (galleryByCardIdRef.value[selectedCardIdRef.value] ?? []) : [])

const selectedImageRef = computed(() => selectedCardRef.value?.images?.find(image => image.imageId === selectedImageIdRef.value))
const selectedImageIndexRef = computed(() => selectedCardRef.value?.images?.findIndex(image => image.imageId === selectedImageIdRef.value) ?? -1)
const lastImageIndexRef = computed(() => (selectedCardRef.value?.images?.length ?? 0) - 1)

// The country name for a flag code, or undefined if it isn't a recognized code.
function flagName(flag?: string) {
  return CountryCodes.toName(flag?.toUpperCase())
}
const flagCountryNameRef = computed(() => flagName(selectedCardRef.value?.flag))

const sortedDetailsRef = computed(() => [...(selectedCardRef.value?.details ?? [])].sort((a, b) => detailSortValue(a) - detailSortValue(b)))

// Bulk detail selection -- FS imports carry a lot of noise (duplicate facts, census rows), so Select
// mode shows a checkbox per detail for multi-delete. Selected by object reference (the list is sorted).
const selectModeRef = ref(false)
const selectedDetailsRef = ref(new Set<GameCardDetail>())
const allDetailsSelectedRef = computed(() => {
  const details = selectedCardRef.value?.details
  return !!details?.length && details.every(detail => selectedDetailsRef.value.has(detail))
})
const someDetailsSelectedRef = computed(() => selectedDetailsRef.value.size > 0 && !allDetailsSelectedRef.value)

onMounted(async () => {
  window.addEventListener('keydown', onKeyDown)
  tokenRef.value = localStorage.getItem(TOKEN_STORAGE_KEY) ?? ''
  if (props.gameId) {
    await loadGame(props.gameId)
  }
})

function persistToken() {
  localStorage.setItem(TOKEN_STORAGE_KEY, tokenRef.value)
}

// Keep the throwaway FS token in localStorage so it survives a reload.
watch(tokenRef, persistToken)

async function loadGame(gameId: string) {
  loadingRef.value = true
  errorRef.value = ''
  try {
    const definition = await gamesApi.getDefinition(gameId)
    titleRef.value = definition?.title ?? ''
    subtitleRef.value = definition?.subtitle ?? ''
    cardsRef.value = await gamesApi.listCardInfo(gameId)
    gameIdRef.value = gameId
    await healAllCards()
    // Select the first card (name order) on load so the editor isn't empty.
    if (!selectedCardIdRef.value && sortedCardsRef.value.length) {
      selectedCardIdRef.value = sortedCardsRef.value[0].id
    }
  } catch (e) {
    errorRef.value = `Couldn't load the game: ${(e as Error).message}`
  } finally {
    loadingRef.value = false
  }
}

async function saveDefinition() {
  const gameId = gameIdRef.value
  if (!gameId) {
    return
  }
  await gamesApi.putDefinition(gameId, {
    id: gameId,
    gameType: 'Matching',
    title: titleRef.value,
    subtitle: subtitleRef.value,
    cards: sortedCardsRef.value.map(c => c.id),
  })
}

// Persist the edited card, debounced. Re-looks-up the card by id at fire time so a since-deleted
// card is a no-op (find returns undefined).
const autosaveCard = debounce((gameId: string, cardId: string) => {
  const card = cardsRef.value.find(c => c.id === cardId)
  if (!card) {
    return
  }
  gamesApi.putCardInfo(gameId, cardId, card).catch(e => { errorRef.value = `Couldn't save the card: ${(e as Error).message}` })
}, 700)

// Deep-watch the selected card: a deep mutation (prev===current, same id) schedules a save; a
// switch (different id) flushes the card we're leaving so its pending edits aren't lost.
watch(selectedCardRef, (card, prev) => {
  if (prev && card && prev.id !== card.id) {
    autosaveCard.flush()
  }
  if (prev && card && prev.id === card.id && gameIdRef.value) {
    autosaveCard(gameIdRef.value, card.id)
  }
}, { deep: true })

// Title/subtitle changes re-persist the definition, debounced.
const autosaveDefinition = debounce(() => {
  saveDefinition().catch(e => { errorRef.value = `Couldn't save the game: ${(e as Error).message}` })
}, 700)
watch([titleRef, subtitleRef], () => {
  if (gameIdRef.value) {
    autosaveDefinition()
  }
})

// Heal ported images: a card ported from the old model carries a legacy `path` and a placeholder
// image id with no blob. Re-upload the path's content (the server assigns a real id), swap it in, and
// drop the path. A failed upload keeps the path so a later pass can retry, and its name is returned
// rather than swallowed -- an unreported failure is how large images once ended up referenced in the
// card but never copied to a blob. Returns whether the card changed (needs saving) and the failures.
async function healImages(card: GameCardInfo) {
  const gameId = gameIdRef.value
  const failed: string[] = []
  let changed = false
  if (!gameId || !card.images) {
    return { changed, failed }
  }
  for (const image of card.images) {
    if (!image.path) {
      continue
    }
    const name = image.path.split('/').pop() ?? image.path
    const blob = await fetch(gamesApi.imagePathUrl(gameId, image.path)).then(r => (r.ok ? r.blob() : null)).catch(() => null)
    if (!blob) {
      failed.push(name)
      continue // leave the path so a later pass can retry
    }
    try {
      const result = await gamesApi.addImage(gameId, blob, name)
      image.imageId = result.imageId
      image.path = undefined
      changed = true
    } catch {
      failed.push(name) // leave the path so a later pass can retry
    }
  }
  return { changed, failed }
}

// Repair every card's ported images once, when the game loads. Uploads that failed under an older
// server size limit are retried here; a healed card is saved explicitly (the autosave watch only
// covers the selected card), and any image that still fails is surfaced rather than left silent.
async function healAllCards() {
  const gameId = gameIdRef.value
  if (!gameId) {
    return
  }
  const failed: string[] = []
  for (const card of cardsRef.value) {
    const result = await healImages(card)
    failed.push(...result.failed)
    if (result.changed) {
      await gamesApi.putCardInfo(gameId, card.id, card)
    }
  }
  if (failed.length) {
    errorRef.value = `Couldn't upload ${failed.length} image(s): ${failed.join(', ')}. They may be too large. Reopen the game to retry.`
  }
}

// Reset per-card UI state (image selection, detail select mode) when switching cards.
watch(selectedCardIdRef, () => {
  selectedImageIdRef.value = undefined
  selectModeRef.value = false
  selectedDetailsRef.value = new Set()
})

onUnmounted(() => {
  window.removeEventListener('keydown', onKeyDown)
  autosaveCard.flush()
  autosaveDefinition.flush()
})

function openNewCard() {
  errorRef.value = ''
  if (!tokenRef.value.trim()) {
    errorRef.value = 'Enter an FS token before adding a card.'
    return
  }
  newCardModalRef.value?.open()
}

async function onAddCard(personId: string) {
  const gameId = gameIdRef.value
  const token = tokenRef.value.trim()
  if (!gameId) {
    return
  }
  if (!token || !personId) {
    errorRef.value = 'Enter an FS token and a person id.'
    newCardModalRef.value?.reset()
    return
  }
  errorRef.value = ''
  try {
    const source = await readGameSourcePerson(personId, token)
    const birthPlace = source.details?.find(d => d.type === 'Birth')?.place
    const card = await gamesApi.addCardInfo(gameId, {
      sourceType: 'FS',
      sourcePersonId: personId,
      name: source.name,
      details: source.details,
      relationship: '',
      flag: CountryCodes.fromName(GeoUtil.getCountryName(birthPlace))?.toLowerCase(),
      childOrder: source.childOrder,
      siblingsCount: source.siblingsCount,
      childCount: source.childCount,
      images: [],
    })
    cardsRef.value.push(card)
    galleryByCardIdRef.value[card.id] = source.images
    selectedCardIdRef.value = card.id
    await saveDefinition()
    newCardModalRef.value?.close()
  } catch (e) {
    errorRef.value = `Couldn't add the card: ${(e as Error).message}`
    newCardModalRef.value?.reset()
  }
}

// Link a ported card that lacks an FS person id: set it (and mark the source FS) so the card can read
// from FamilySearch. The input shows only while the id is absent -- an established linkage is read-only.
function setPersonId(event: Event) {
  const card = selectedCardRef.value
  const value = (event.target as HTMLInputElement).value.trim().toUpperCase()
  if (card && value) {
    card.sourceType = 'FS'
    card.sourcePersonId = value
  }
}

// Re-reads the person from FamilySearch and refreshes the card's name/details/gallery in
// place -- the deep watch on the selected card auto-saves the refreshed values.
async function readCardFromFamilySearch() {
  const card = selectedCardRef.value
  const personId = selectedPersonIdRef.value
  const token = tokenRef.value.trim()
  if (!card || !personId) {
    return
  }
  if (!token) {
    errorRef.value = 'Enter an FS token.'
    return
  }
  savingRef.value = true
  errorRef.value = ''
  try {
    const source = await readGameSourcePerson(personId, token)
    card.name = source.name
    card.details = source.details
    card.childOrder = source.childOrder ?? card.childOrder
    card.siblingsCount = source.siblingsCount ?? card.siblingsCount
    card.childCount = source.childCount ?? card.childCount
    galleryByCardIdRef.value[card.id] = source.images
  } catch (e) {
    errorRef.value = `Couldn't read from FamilySearch: ${(e as Error).message}`
  } finally {
    savingRef.value = false
  }
}

// A cleared number field yields an empty value -- store undefined rather than NaN.
function setNumber(field: 'childOrder' | 'siblingsCount' | 'childCount', event: Event) {
  const card = selectedCardRef.value
  if (!card) {
    return
  }
  const raw = (event.target as HTMLInputElement).value
  card[field] = raw === '' ? undefined : Number(raw)
}

// Order life events chronologically -- dateless details sort to the end.
function detailSortValue(detail: GameCardDetail) {
  return parseDate(detail.date)?.sortValue ?? Number.MAX_SAFE_INTEGER
}

// The card's age at a detail's date -- birth year to this detail's year, when both are known.
function detailAge(detail: GameCardDetail) {
  const birthYear = parseDate(selectedCardRef.value?.details?.find(d => d.type === 'Birth')?.date)?.year
  const year = parseDate(detail.date)?.year
  return birthYear !== undefined && year !== undefined ? year - birthYear : undefined
}

// relationship path from the root person: F (father) = blue square, M (mother) = pink square.
function relationshipSquares(relationship?: string) {
  return [...(relationship ?? '')].map(step => (step === 'F' ? 'f' : 'm'))
}

function openEditDetail(detail: GameCardDetail) {
  editDetailRef.value = detail
  editDetailModalRef.value?.open({ ...detail })
}

// A new detail is added rather than edited -- signalled by a cleared reference.
function openAddDetail() {
  editDetailRef.value = undefined
  editDetailModalRef.value?.open({ type: '' })
}

// Add a new detail or replace the edited one in place -- the deep watch auto-saves it. The list
// is displayed date-sorted, so edits target the detail by reference rather than a display index.
function onSaveDetail(updated: GameCardDetail) {
  const card = selectedCardRef.value
  if (card) {
    if (!card.details) {
      card.details = []
    }
    const index = editDetailRef.value ? card.details.indexOf(editDetailRef.value) : -1
    if (index >= 0) {
      card.details.splice(index, 1, updated)
    } else {
      card.details.push(updated)
    }
  }
  editDetailModalRef.value?.close()
}

function onDeleteDetail() {
  const card = selectedCardRef.value
  const index = editDetailRef.value ? (card?.details?.indexOf(editDetailRef.value) ?? -1) : -1
  if (card?.details && index >= 0) {
    card.details.splice(index, 1)
  }
  editDetailModalRef.value?.close()
}

function toggleSelectMode() {
  selectModeRef.value = !selectModeRef.value
  selectedDetailsRef.value = new Set()
}

function toggleDetailSelected(detail: GameCardDetail) {
  const selected = new Set(selectedDetailsRef.value)
  if (selected.has(detail)) {
    selected.delete(detail)
  } else {
    selected.add(detail)
  }
  selectedDetailsRef.value = selected
}

function toggleSelectAll() {
  selectedDetailsRef.value = allDetailsSelectedRef.value ? new Set() : new Set(selectedCardRef.value?.details ?? [])
}

// Drop the selected details in one pass (no per-row confirm -- they're re-importable from FS).
function deleteSelectedDetails() {
  const card = selectedCardRef.value
  if (card?.details) {
    card.details = card.details.filter(detail => !selectedDetailsRef.value.has(detail))
  }
  selectedDetailsRef.value = new Set()
}

async function openAddImage() {
  imageGalleryModalRef.value?.open()
  await ensureGallery()
}

// For an FS-sourced card whose gallery hasn't been loaded this session, fetch just the memories --
// not the person's facts -- so the picker isn't empty without re-reading (and clobbering) the card.
async function ensureGallery() {
  const card = selectedCardRef.value
  const personId = selectedPersonIdRef.value
  const token = tokenRef.value.trim()
  if (!card || !personId || !token || card.id in galleryByCardIdRef.value) {
    return
  }
  loadingGalleryRef.value = true
  try {
    galleryByCardIdRef.value[card.id] = await readGameSourceImages(personId, token)
  } catch (e) {
    imageGalleryModalRef.value?.showError(`Couldn't load FamilySearch memories: ${(e as Error).message}`)
  } finally {
    loadingGalleryRef.value = false
  }
}

async function onSelectImage(selection: { source: SourceImage } | { file: File }) {
  const gameId = gameIdRef.value
  const card = selectedCardRef.value
  if (!gameId || !card) {
    return
  }
  try {
    let imageId: string
    if ('file' in selection) {
      const result = await gamesApi.addImage(gameId, selection.file, selection.file.name)
      imageId = result.imageId
    } else {
      // FS may CORS-block the original-bytes fetch -- surface a clear, actionable message.
      let blob: Blob
      try {
        blob = await (await fetch(selection.source.originalUrl)).blob()
      } catch {
        imageGalleryModalRef.value?.showError("Couldn't fetch this image from FamilySearch — try downloading and uploading it as a file.")
        return
      }
      const result = await gamesApi.addImage(gameId, blob, selection.source.filename)
      imageId = result.imageId
    }
    if (!card.images) {
      card.images = []
    }
    card.images.push({ imageId, focusX: 0.5, focusY: 0.5, zoom: 1 })
  } catch (e) {
    imageGalleryModalRef.value?.showError(`Couldn't add the image: ${(e as Error).message}`)
  }
}

// Each tile is a click-to-select inline cropper. Once selected, drag pans and Ctrl+wheel zooms toward
// the cursor -- both act on the selected image by id (not DOM focus), so the reorder buttons stay
// clickable without dropping the selection. A plain wheel scrolls the page. Mutating the image object
// triggers the deep-watch auto-save.
let dragImage: GameCardImage | null = null
let dragTile: HTMLElement | null = null
let dragImg: HTMLImageElement | null = null
let dragLastX = 0
let dragLastY = 0
let dragTravel = 0

function onTileDown(event: PointerEvent, image: GameCardImage) {
  if (event.button !== 0) {
    // ignore right/middle click -- leave the context menu alone
    return
  }
  const tile = event.currentTarget as HTMLElement
  tile.setPointerCapture(event.pointerId)
  dragImage = image
  dragTile = tile
  dragImg = tile.querySelector('img')
  dragLastX = event.clientX
  dragLastY = event.clientY
  dragTravel = 0
}

function onTileMove(event: PointerEvent, image: GameCardImage) {
  if (dragImage !== image || event.buttons === 0) {
    return
  }
  const dx = event.clientX - dragLastX
  const dy = event.clientY - dragLastY
  dragLastX = event.clientX
  dragLastY = event.clientY
  dragTravel += Math.abs(dx) + Math.abs(dy)
  // Only the selected tile crops -- keep accumulating travel so an unselected tile still clicks.
  const selected = selectedImageIdRef.value === image.imageId
  if (!selected || !dragTile || !dragImg?.naturalWidth) {
    return
  }
  const focal = { focusX: image.focusX ?? 0.5, focusY: image.focusY ?? 0.5, zoom: image.zoom ?? 1 }
  const next = panFocal(focal, dx, dy, dragImg.naturalWidth, dragImg.naturalHeight, dragTile.clientWidth, dragTile.clientHeight)
  image.focusX = next.focusX
  image.focusY = next.focusY
}

function onTileUp(event: PointerEvent, image: GameCardImage) {
  if (dragImage === image) {
    // A press that barely moved is a click -> toggle selection (drag and Ctrl+wheel then act on it).
    if (dragTravel < 4) {
      selectedImageIdRef.value = selectedImageIdRef.value === image.imageId ? undefined : image.imageId
    }
    if (dragTile?.hasPointerCapture(event.pointerId)) {
      dragTile.releasePointerCapture(event.pointerId)
    }
  }
  dragImage = null
  dragTile = null
  dragImg = null
}

function onTileWheel(event: WheelEvent, image: GameCardImage) {
  // Ctrl+wheel (also a trackpad pinch) zooms the selected tile; a plain wheel scrolls the page.
  const selected = selectedImageIdRef.value === image.imageId
  if (!selected || !event.ctrlKey) {
    return
  }
  const tile = event.currentTarget as HTMLElement
  const img = tile.querySelector('img')
  if (!img?.naturalWidth) {
    return
  }
  event.preventDefault()
  const factor = event.deltaY < 0 ? 1.1 : 1 / 1.1
  // Cursor in the tile's content box (clientLeft/Top strip the border) so it matches v-focal.
  const rect = tile.getBoundingClientRect()
  const px = event.clientX - rect.left - tile.clientLeft
  const py = event.clientY - rect.top - tile.clientTop
  const focal = { focusX: image.focusX ?? 0.5, focusY: image.focusY ?? 0.5, zoom: image.zoom ?? 1 }
  const next = zoomFocalToward(focal, focal.zoom * factor, px, py, img.naturalWidth, img.naturalHeight, tile.clientWidth, tile.clientHeight)
  image.focusX = next.focusX
  image.focusY = next.focusY
  image.zoom = next.zoom
}

// Delete removes the selected image, unless a text field has focus (Delete edits text there).
function onKeyDown(event: KeyboardEvent) {
  if (event.key !== 'Delete' || !selectedImageIdRef.value) {
    return
  }
  const active = document.activeElement?.tagName
  if (active === 'INPUT' || active === 'TEXTAREA') {
    return
  }
  deleteSelectedImage()
}

async function deleteSelectedImage() {
  const gameId = gameIdRef.value
  const card = selectedCardRef.value
  const imageId = selectedImageIdRef.value
  const removeAt = card?.images?.findIndex(x => x.imageId === imageId) ?? -1
  if (!gameId || !card || !imageId || removeAt < 0) {
    return
  }
  try {
    await gamesApi.deleteImage(gameId, imageId)
    card.images?.splice(removeAt, 1)
    selectedImageIdRef.value = undefined
  } catch (e) {
    errorRef.value = `Couldn't remove the image: ${(e as Error).message}`
  }
}

// Reorder the selected image within the card's gallery -- the first image is the primary (the card's
// face). Drag is reserved for cropping, so ordering is done with these explicit controls.
function moveSelectedImage(delta: number) {
  const images = selectedCardRef.value?.images
  const from = selectedImageIndexRef.value
  const to = from + delta
  if (!images || from < 0 || to < 0 || to >= images.length) {
    return
  }
  const [image] = images.splice(from, 1)
  images.splice(to, 0, image)
}

function makeSelectedPrimary() {
  const images = selectedCardRef.value?.images
  const from = selectedImageIndexRef.value
  if (!images || from <= 0) {
    return
  }
  const [image] = images.splice(from, 1)
  images.unshift(image)
}

async function deleteSelectedCard() {
  const gameId = gameIdRef.value
  const card = selectedCardRef.value
  if (!gameId || !card) {
    return
  }
  const confirmed = await confirmDelete.ask()
  if (!confirmed) {
    return
  }
  savingRef.value = true
  errorRef.value = ''
  try {
    // Cancel any pending card save so it can't re-PUT the card we're about to delete.
    autosaveCard.cancel()
    await gamesApi.deleteCardInfo(gameId, card.id)
    cardsRef.value = cardsRef.value.filter(c => c.id !== card.id)
    delete galleryByCardIdRef.value[card.id]
    selectedCardIdRef.value = undefined
    await saveDefinition()
  } catch (e) {
    errorRef.value = `Couldn't delete the card: ${(e as Error).message}`
  } finally {
    savingRef.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("label", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tokenRef).value = $event)),
          placeholder: "FamilySearch access token",
          autocomplete: "off",
          spellcheck: "false"
        }, null, 512), [
          [
            _vModelText,
            tokenRef.value,
            void 0,
            { trim: true }
          ]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("label", null, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((titleRef).value = $event)),
          placeholder: "Game title",
          autocomplete: "off"
        }, null, 512), [
          [
            _vModelText,
            titleRef.value,
            void 0,
            { trim: true }
          ]
        ])
      ]),
      _createElementVNode("label", null, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "form-control",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((subtitleRef).value = $event)),
          placeholder: "Game subtitle",
          autocomplete: "off"
        }, null, 512), [
          [
            _vModelText,
            subtitleRef.value,
            void 0,
            { trim: true }
          ]
        ])
      ])
    ]),
    (errorRef.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(errorRef.value), 1))
      : _createCommentVNode("", true),
    (loadingRef.value)
      ? (_openBlock(), _createBlock(LoadingIndicator, { key: 1 }))
      : _createCommentVNode("", true),
    (gameIdRef.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h4", null, [
              _createTextVNode("Cards "),
              (sortedCardsRef.value.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "(" + _toDisplayString(sortedCardsRef.value.length) + ")", 1))
                : _createCommentVNode("", true)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedCardsRef.value, (card) => {
              return (_openBlock(), _createElementBlock("button", {
                key: card.id,
                type: "button",
                class: _normalizeClass(["card-item", { selected: card.id === selectedCardIdRef.value }]),
                onClick: ($event: any) => (selectedCardIdRef.value = card.id)
              }, [
                _createElementVNode("span", _hoisted_14, [
                  (card.images?.length)
                    ? _withDirectives((_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _unref(gamesApi).imageUrl(gameIdRef.value, card.images[0].imageId),
                        alt: ""
                      }, null, 8, _hoisted_15)), [
                        [_unref(vFocal), { focusX: card.images[0].focusX ?? 0.5, focusY: card.images[0].focusY ?? 0.5, zoom: card.images[0].zoom ?? 1 }]
                      ])
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("span", _hoisted_16, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(card.name || '(unnamed)'), 1),
                  (card.relationship)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relationshipSquares(card.relationship), (step, i) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: i,
                            class: _normalizeClass(["rel-square", step])
                          }, null, 2))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (flagName(card.flag))
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      class: _normalizeClass(["fi card-flag", `fi-${card.flag}`]),
                      title: flagName(card.flag)
                    }, null, 10, _hoisted_19))
                  : _createCommentVNode("", true)
              ], 10, _hoisted_13))
            }), 128)),
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-link new-card",
              onClick: openNewCard
            }, "+ Add card")
          ]),
          (selectedCardRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  (selectedCardRef.value.sourcePersonId)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(selectedCardRef.value.sourcePersonId), 1))
                    : (_openBlock(), _createElementBlock("input", {
                        key: 1,
                        type: "text",
                        class: "form-control person-id-input",
                        placeholder: "Add FamilySearch id, e.g. KWJH-FC3",
                        onChange: _cache[3] || (_cache[3] = ($event: any) => (setPersonId($event)))
                      }, null, 32)),
                  _createElementVNode("button", {
                    class: "btn btn-link",
                    disabled: !selectedPersonIdRef.value || savingRef.value,
                    onClick: readCardFromFamilySearch
                  }, "Read from FamilySearch", 8, _hoisted_25)
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control field-name",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedCardRef.value.name) = $event))
                    }, null, 512), [
                      [_vModelText, selectedCardRef.value.name]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control field-relationship",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedCardRef.value.relationship) = $event))
                    }, null, 512), [
                      [_vModelText, selectedCardRef.value.relationship]
                    ]),
                    _hoisted_31
                  ]),
                  (selectedCardRef.value.relationship)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _hoisted_33,
                        _createElementVNode("span", _hoisted_34, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(relationshipSquares(selectedCardRef.value.relationship), (step, i) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: i,
                              class: _normalizeClass(["rel-square", step])
                            }, null, 2))
                          }), 128))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_35, [
                    _hoisted_36,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control field-wide",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((selectedCardRef.value.text) = $event))
                    }, null, 512), [
                      [_vModelText, selectedCardRef.value.text]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createElementVNode("input", {
                      type: "number",
                      class: "form-control field-number",
                      value: selectedCardRef.value.childOrder,
                      onInput: _cache[7] || (_cache[7] = ($event: any) => (setNumber('childOrder', $event)))
                    }, null, 40, _hoisted_39),
                    _hoisted_40,
                    _createElementVNode("input", {
                      type: "number",
                      class: "form-control field-number",
                      value: selectedCardRef.value.siblingsCount,
                      onInput: _cache[8] || (_cache[8] = ($event: any) => (setNumber('siblingsCount', $event)))
                    }, null, 40, _hoisted_41)
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createElementVNode("input", {
                      type: "number",
                      class: "form-control field-number",
                      value: selectedCardRef.value.childCount,
                      onInput: _cache[9] || (_cache[9] = ($event: any) => (setNumber('childCount', $event)))
                    }, null, 40, _hoisted_44)
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _hoisted_46,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control field-flag",
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((selectedCardRef.value.flag) = $event)),
                      placeholder: "e.g. gb-eng",
                      maxlength: "6"
                    }, null, 512), [
                      [_vModelText, selectedCardRef.value.flag]
                    ]),
                    (selectedCardRef.value.flag)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: _normalizeClass(["fi", `fi-${selectedCardRef.value.flag}`])
                        }, null, 2))
                      : _createCommentVNode("", true),
                    (flagCountryNameRef.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(flagCountryNameRef.value), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_48, [
                    _hoisted_49,
                    _withDirectives(_createElementVNode("textarea", {
                      class: "form-control field-wide",
                      rows: "3",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((selectedCardRef.value.notes) = $event))
                    }, null, 512), [
                      [_vModelText, selectedCardRef.value.notes]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_50, [
                  (selectedCardRef.value.images?.length)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: _normalizeClass(["tile primary", { selected: selectedCardRef.value.images[0].imageId === selectedImageIdRef.value }]),
                        tabindex: "0",
                        onPointerdown: _cache[12] || (_cache[12] = ($event: any) => (onTileDown($event, selectedCardRef.value.images[0]))),
                        onPointermove: _cache[13] || (_cache[13] = ($event: any) => (onTileMove($event, selectedCardRef.value.images[0]))),
                        onPointerup: _cache[14] || (_cache[14] = ($event: any) => (onTileUp($event, selectedCardRef.value.images[0]))),
                        onPointercancel: _cache[15] || (_cache[15] = ($event: any) => (onTileUp($event, selectedCardRef.value.images[0]))),
                        onWheel: _cache[16] || (_cache[16] = ($event: any) => (onTileWheel($event, selectedCardRef.value.images[0]))),
                        onDragstart: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["prevent"]))
                      }, [
                        _withDirectives(_createElementVNode("img", {
                          src: _unref(gamesApi).imageUrl(gameIdRef.value, selectedCardRef.value.images[0].imageId),
                          alt: "",
                          draggable: "false"
                        }, null, 8, _hoisted_51), [
                          [_unref(vFocal), { focusX: selectedCardRef.value.images[0].focusX ?? 0.5, focusY: selectedCardRef.value.images[0].focusY ?? 0.5, zoom: selectedCardRef.value.images[0].zoom ?? 1 }]
                        ])
                      ], 34))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "tile add primary",
                        onClick: openAddImage
                      }, [
                        _createVNode(_unref(PlusIcon))
                      ])),
                  (selectedCardRef.value.images?.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedCardRef.value.images.slice(1), (image) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: image.imageId,
                            class: _normalizeClass(["tile", { selected: image.imageId === selectedImageIdRef.value }]),
                            tabindex: "0",
                            onPointerdown: ($event: any) => (onTileDown($event, image)),
                            onPointermove: ($event: any) => (onTileMove($event, image)),
                            onPointerup: ($event: any) => (onTileUp($event, image)),
                            onPointercancel: ($event: any) => (onTileUp($event, image)),
                            onWheel: ($event: any) => (onTileWheel($event, image)),
                            onDragstart: _cache[18] || (_cache[18] = _withModifiers(() => {}, ["prevent"]))
                          }, [
                            _withDirectives(_createElementVNode("img", {
                              src: _unref(gamesApi).imageUrl(gameIdRef.value, image.imageId),
                              alt: "",
                              draggable: "false"
                            }, null, 8, _hoisted_54), [
                              [_unref(vFocal), { focusX: image.focusX ?? 0.5, focusY: image.focusY ?? 0.5, zoom: image.zoom ?? 1 }]
                            ])
                          ], 42, _hoisted_53))
                        }), 128)),
                        _createElementVNode("button", {
                          type: "button",
                          class: "tile add small",
                          onClick: openAddImage
                        }, [
                          _createVNode(_unref(PlusIcon))
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (selectedImageRef.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-link",
                        disabled: selectedImageIndexRef.value === 0,
                        onClick: makeSelectedPrimary
                      }, "Make primary", 8, _hoisted_56),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-link",
                        disabled: selectedImageIndexRef.value === 0,
                        onClick: _cache[19] || (_cache[19] = ($event: any) => (moveSelectedImage(-1))),
                        "aria-label": "Move earlier"
                      }, [
                        _createVNode(_unref(ChevronLeftIcon))
                      ], 8, _hoisted_57),
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-link",
                        disabled: selectedImageIndexRef.value === lastImageIndexRef.value,
                        onClick: _cache[20] || (_cache[20] = ($event: any) => (moveSelectedImage(1))),
                        "aria-label": "Move later"
                      }, [
                        _createVNode(_unref(ChevronRightIcon))
                      ], 8, _hoisted_58)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("div", _hoisted_60, [
                    _hoisted_61,
                    _createElementVNode("div", _hoisted_62, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "btn btn-link select-toggle",
                        onClick: toggleSelectMode
                      }, _toDisplayString(selectModeRef.value ? 'Done' : 'Select'), 1),
                      (selectModeRef.value)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            type: "button",
                            class: "btn btn-link delete-selected",
                            disabled: !selectedDetailsRef.value.size,
                            onClick: deleteSelectedDetails,
                            "aria-label": "Delete selected details"
                          }, [
                            _createVNode(_unref(Trash2Icon))
                          ], 8, _hoisted_63))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    (selectModeRef.value)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_65, [
                          _createElementVNode("input", {
                            type: "checkbox",
                            checked: allDetailsSelectedRef.value,
                            indeterminate: someDetailsSelectedRef.value,
                            onChange: toggleSelectAll
                          }, null, 40, _hoisted_66),
                          _hoisted_67
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedDetailsRef.value, (detail, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: _normalizeClass(["detail", { highlight: detail.highlight }])
                      }, [
                        (selectModeRef.value)
                          ? (_openBlock(), _createElementBlock("input", {
                              key: 0,
                              type: "checkbox",
                              class: "detail-check",
                              checked: selectedDetailsRef.value.has(detail),
                              onChange: ($event: any) => (toggleDetailSelected(detail))
                            }, null, 40, _hoisted_68))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", _hoisted_69, _toDisplayString(_unref(formatDate)(detail.date)), 1),
                        _createElementVNode("span", _hoisted_70, _toDisplayString(detailAge(detail) ?? ''), 1),
                        _createElementVNode("div", _hoisted_71, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-link detail-type",
                            onClick: ($event: any) => (openEditDetail(detail))
                          }, _toDisplayString(detail.type), 9, _hoisted_72),
                          (detail.place)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_73, _toDisplayString(detail.place), 1))
                            : _createCommentVNode("", true)
                        ]),
                        (detail.flag)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: _normalizeClass(["fi detail-flag", `fi-${detail.flag}`])
                            }, null, 2))
                          : _createCommentVNode("", true)
                      ], 2))
                    }), 128)),
                    (!selectModeRef.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 1,
                          type: "button",
                          class: "btn btn-link add-detail",
                          onClick: openAddDetail
                        }, "+ Add detail"))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("button", {
                    class: "btn btn-outline-danger",
                    disabled: savingRef.value,
                    onClick: deleteSelectedCard
                  }, "Delete card", 8, _hoisted_75)
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createVNode(NewCardModal, {
      ref_key: "newCardModalRef",
      ref: newCardModalRef,
      onAdd: onAddCard
    }, null, 512),
    _createVNode(EditDetailModal, {
      ref_key: "editDetailModalRef",
      ref: editDetailModalRef,
      onSave: onSaveDetail,
      onDelete: onDeleteDetail
    }, null, 512),
    _createVNode(ImageGalleryModal, {
      ref_key: "imageGalleryModalRef",
      ref: imageGalleryModalRef,
      images: selectedGalleryRef.value,
      loading: loadingGalleryRef.value,
      onSelect: onSelectImage
    }, null, 8, ["images", "loading"]),
    _createVNode(Modal, {
      ref_key: "deleteModalRef",
      ref: deleteModalRef,
      "ok-style": "danger",
      "ok-text": "Delete",
      onOk: _unref(confirmDelete).confirm,
      onHidden: _unref(confirmDelete).dismiss
    }, {
      title: _withCtx(() => [
        _createTextVNode("Delete card")
      ]),
      default: _withCtx(() => [
        _hoisted_76
      ]),
      _: 1
    }, 8, ["onOk", "onHidden"])
  ]))
}
}

})